import { Card, Chip } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { server } from "../../server";
import {
    RiSearchLine,
    RiUserUnfollowLine,
    RiShieldFlashFill,
    RiErrorWarningLine,
    RiArrowRightSLine
} from "react-icons/ri";

export default function UserRejectedList() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [rejectedUsers, setRejectedUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const getAllRejectedUsers = async () => {
        try {
            setLoading(true);
            const { data } = await axios.get(`${server}/auth/getallUsers`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("bvmToken")}`,
                },
                params: { pageNo: 1, pageSize: 10000, verified: null, admin: false, status: "rejected" }
            });
            setRejectedUsers(data?.data || []);
        } catch (e) {
            toast.error(e?.response?.data?.message || e?.message || "Failed to fetch rejected users");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getAllRejectedUsers();
    }, []);

    const filteredUsers = rejectedUsers.filter(
        (user) =>
            user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            user.userName?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="p-4 lg:p-6 bg-[#fbfcfd] min-h-screen">
            <div className="w-full mx-auto space-y-6">
                {/* Header Section */}
                <div className="flex flex-col xl:flex-row xl:items-center justify-between gap-4">
                    <div className="space-y-1">
                        <h1 className="text-3xl font-semibold text-slate-900 tracking-tight leading-none">Rejected Applications</h1>
                        <p className="text-slate-500 font-semibold text-sm italic">Review users whose verification requests were declined.</p>
                    </div>

                    <div className="relative w-full xl:w-[400px] group transition-all">
                        <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                            <RiSearchLine className="text-slate-400 text-lg group-focus-within:text-red-500 transition-colors" />
                        </div>
                        <input
                            type="text"
                            placeholder="Search rejected users..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            className="pl-10 pr-4 py-2.5 w-full border border-slate-200 rounded-xl focus:outline-none focus:ring-[4px] focus:ring-red-500/5 focus:border-red-500 bg-white text-slate-800 shadow-sm transition-all text-sm font-bold placeholder:text-slate-400"
                        />
                    </div>
                </div>

                {/* Main Content Card */}
                <Card className="rounded-2xl shadow-xl shadow-red-900/5 border border-slate-200/50 bg-white overflow-hidden">
                    <div className="p-4 lg:p-6">
                        {loading && rejectedUsers.length === 0 ? (
                            <div className="py-20 text-center space-y-4">
                                <div className="animate-spin h-10 w-10 border-[4px] border-red-600 border-t-transparent rounded-full mx-auto"></div>
                                <p className="text-slate-500 font-bold text-sm">Fetching Data...</p>
                            </div>
                        ) : filteredUsers.length === 0 ? (
                            <div className="py-20 text-center space-y-4 bg-slate-50/50 rounded-2xl border-2 border-dashed border-slate-100">
                                <RiUserUnfollowLine className="text-4xl text-slate-200 mx-auto" />
                                <p className="text-slate-500 font-bold">No Rejected Users Found</p>
                            </div>
                        ) : (
                            <div className="overflow-x-auto rounded-xl border border-slate-100">
                                <table className="w-full text-left border-collapse">
                                    <thead>
                                        <tr className="bg-slate-50 text-[10px] font-semibold text-slate-400 uppercase tracking-wider border-b border-slate-100">
                                            <th className="px-6 py-4">User</th>
                                            <th className="px-6 py-4">Username</th>
                                            <th className="px-6 py-4">Status</th>
                                            <th className="px-6 py-4">Remarks</th>
                                            {/* <th className="px-6 py-4 text-right">Details</th> */}
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-slate-50">
                                        {filteredUsers.map(user => (
                                            <tr
                                                key={user.id}
                                                className="hover:bg-red-50/20 text-sm cursor-pointer transition-colors"
                                                onClick={() => navigate("../userDetails", { state: { user } })}
                                            >
                                                <td className="px-6 py-4">
                                                    <div className="flex items-center gap-3">
                                                        <div className="w-8 h-8 rounded-lg bg-red-50 flex items-center justify-center text-red-500 font-semibold text-xs">
                                                            {user.name?.charAt(0) || "R"}
                                                        </div>
                                                        <span className="font-bold text-slate-800 uppercase tracking-tight">{user.name}</span>
                                                    </div>
                                                </td>
                                                <td className="px-6 py-4 font-bold text-slate-600">{user.userName}</td>
                                                <td className="px-6 py-4">
                                                    <div className="flex items-center gap-1.5 px-2 py-1 bg-red-50 text-red-600 rounded-lg border border-red-100/50 w-fit">
                                                        <div className="w-1.5 h-1.5 rounded-full bg-red-500"></div>
                                                        <span className="text-[10px] font-semibold tracking-wider">REJECTED</span>
                                                    </div>
                                                </td>


                                                 <td className="px-6 py-4">
                                                    <div className="flex items-center gap-1.5 px-2 py-1 text-black w-fit">
                                                   
                                                        <span className="text-[10px] font-semibold tracking-wider">{user.remarks ?? "N/A"}</span>
                                                    </div>
                                                </td>
                                                {/* <td className="px-6 py-4 text-right">
                                                    <RiArrowRightSLine className="text-slate-300 ml-auto text-xl" />
                                                </td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </Card>
            </div>

            <style>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 5px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f8fafc;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #e2e8f0;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #cbd5e1;
        }
      `}</style>
        </div>
    );
}